import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getRedirectPath } from '../../config/userTypes';

const PrivateRoute = ({ children, authType }) => {
  const { isAuthenticated, getAuthType } = useAuth();
  const location = useLocation();
  const currentAuthType = getAuthType();

  if (!isAuthenticated) {
    return <Navigate to="/signin" state={{ from: location }} replace />;
  }

  if (authType && authType !== currentAuthType) {
    return <Navigate to={getRedirectPath(currentAuthType)} replace />;
  }

  return children;
};

export default PrivateRoute; 